import React from 'react';
import { Button, ButtonProps, Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { confirm } = Modal;

interface ConfirmButtonProps {
  title?: string;
}

const ConfirmButton: React.FC<ButtonProps & ConfirmButtonProps> = props => {
  const { onClick, children, title } = props;
  const showConfirm = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    confirm({
      title: title || 'Вы точно хотите осуществить изменение ?',
      icon: <ExclamationCircleOutlined />,
      onOk() {
        onClick && onClick(e);
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };
  return (
    <Button {...props} onClick={showConfirm}>
      {children}
    </Button>
  );
};

export default ConfirmButton;
